module.exports = __webpack_public_path__ + "static/img/ent-15.825abf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-15.jpg
// module id = hV+R
// module chunks = 52